import { Content, Horizontal, StretchSpacer, Vertical } from "gls/lib";
import React from "react";
import { useTranslation } from "react-i18next";
import { style, stylesheet } from "typestyle";
import { Colours, fontFamily, Sizes } from "../../styles";
import { Form } from "../Form/Form";
import { FormTextInput } from "../Form/FormTextInput";
import { FormState } from "../Form/types";
import { isMandatory } from "../Form/validators/isMandatoryValidator";

export interface UsernamePasswordLoginProps {
  onSubmit: (username: string, password: string) => void;
  onForgotPassword?: () => void;
}

export const UsernamePasswordLogin: React.FC<UsernamePasswordLoginProps> = ({
  onSubmit,
  onForgotPassword,
}) => {
  const { t } = useTranslation();
  const onSubmitHandler = ({ username, password }: FormState) => {
    onSubmit(username.value, password.value);
  };

  return (
    <Vertical
      width={300}
      spacing={15}
      className={style({ fontFamily: fontFamily })}
      data-testid="login-username-password"
    >
      <Form
        title={t("Login")}
        onSubmit={onSubmitHandler}
        submitButtonText={t("Login")}
      >
        <FormTextInput
          label={t("Username")}
          name="username"
          validators={[isMandatory]}
        />

        <FormTextInput
          name="password"
          password
          label={
            <Horizontal>
              <Content>{t("Password")}</Content>
              {onForgotPassword && (
                <>
                  <StretchSpacer />
                  <Content
                    horizontalAlign="right"
                    className={classNames.passwordLabel}
                    onClick={() => onForgotPassword?.()}
                  >
                    {t("Forgot password?")}
                  </Content>
                </>
              )}
            </Horizontal>
          }
          validators={[isMandatory]}
        />
      </Form>
    </Vertical>
  );
};

const classNames = stylesheet({
  passwordLabel: {
    color: Colours.textDark,
    cursor: "pointer",
    fontSize: Sizes.fontSize1,
    $nest: {
      "&:hover": {
        color: Colours.textLight,
      },
    },
  },
});
